module.exports = __webpack_public_path__ + "media/images/riders/DEFAULT-c4a21c4bde91243c960624544d6f0132.png";